/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Общий вид для страницы товаров в претензии.
   */
  app.NewClaimItemsCommonView = app.View.extend({
    el: '[data-jsview="claim-items"] .reducer:not(.reducer_col)',
    additionalOptions: ['mainWindow', 'bodyView'],
    events: {
      'click .add-claim-item': 'addClaimItem',
      'click .send-claim': 'sendClaim',
      'click .save-temp': 'saveClaim',
      'click .js-popup-close, .claim-cancel': 'closeClaimItem',
      'click .claim-cancel, .js-popup-close': 'cancelClaim',
    },
    run: function () {
      this.claimsNumberTemplate = app.helpers.TemplateHelper.getTemplate('#claims-number-template');
      this.urlParams = app.helpers.UrlHelper.getUrlParameters();
      this.claim_id = this.$el.find('#claim-edit').data('claim-id');
      this.claimModel = new app.Claim({
        id: this.claim_id
      });
      this.collection = this.model;
      this.collection.claim_id = this.claim_id;
      this.initPagination();
      this.initPopup();
      this.initAsideLoader();
      this.initItemsLoader();
      this.collection.getFirstPage();
      this.listenTo(this.collection, 'remove', this.removeView);
      this.listenTo(this.collection, 'request', this.renderItemsLoader);
      this.listenTo(this.collection, 'error', this.removeItemsLoader);
      this.listenTo(this.collection, 'sync', this.onSync);
      this.listenTo(this.collection, 'claimItemView:removeClaim', this.onRemoveByUser);
      this.listenTo(Backbone, 'item-view-saved', this.getLastPage);
      this.listenTo(Backbone, 'item-view-saved', this.closeClaimItem);
      this.listenTo(Backbone, 'item-view-edit', this.showPopup);
      this.listenTo(Backbone, 'item-view-cancel-popup', this.cancelClaim);
      this.listenTo(Backbone, 'open-more-claim-item', this.addClaimItem);
    },

    /**
     * Обновление списка товаров в претензии.
     */
    onSync: function () {
      if (this.childViews.claimItemForm) {
        this.collection.add(this.childViews.claimItemForm.model);
      }
      this.claimsCount = this.collection.state.totalRecords;
      this.render();

      if (this.collection.models.length === 0 && this.collection.state.currentPage === 1) {
        this.addClaimItem();
      }
      this.removeItemsLoader();
    },

    /**
     * Переход на последнюю страницу
     */
    getLastPage: function() {
      this.collection.getLastPage();
    },

    /**
     * Удаление товара из претензии.
     */
    onRemoveByUser: function () {
      this.claimsCount--;
      var isLastPage = this.collection.state.currentPage === this.collection.state.lastPage;
      if (isLastPage) {
        if (this.collection.models.length === 0) {
          if (this.collection.state.currentPage > 1) {
            this.collection.getPage(this.collection.state.currentPage - 1);
          } else {
            this.addClaimItem();
          }
        }
      } else {
        if (this.claimsCount % this.collection.state.pageSize === 0) {
          this.collection.getPage(this.collection.state.currentPage);
        }
      }
      this.renderAsideCounter();
      this.removeItemsLoader();
    },

    /**
     * Инициализация пагинации.
     */
    initPagination: function () {
      this.childViews.paginationView = new app.CabinetReviewsPaginationView({
        model: this.collection,
        btnView: app.CabinetReviewsPaginationButtonView
      });
      if (this.childViews.paginationView) {
        this.listenTo(Backbone, 'review-paginate', this.paginate);
      }
      this.childViews.paginationView.render();
    },

    /**
     * Отрисовка страницы товаров в претензии.
     * @returns {app.NewClaimItemsCommonView}
     */
    render: function () {
      var that = this;
      _.each(this.childViews.claimItems, function (view) {
        view.remove();
      });
      if (!this.childViews.claimItems) {
        this.childViews.claimItems = [];
      }
      _.each(this.collection.models, function (num) {
        var element = that.$('[data-id=' + num.id + ']'),
          itemView;
        itemView = new app.NewClaimItemView({
          cid: num.cid,
          model: num,
          el: element
        });
        that.childViews.claimItems.push(itemView);
        if (!element.length) {
          that.$el.find('#claim-edit').append(itemView.render(false, true).el);
        }
      });
      this.popup.close();
      this.showAddingButton();
      this.renderAsideCounter();
      return this;
    },

    /**
     * Показывает или скрывает правый блок.
     */
    renderAsideCounter: function () {
      if (this.collection.models.length === 0 || this.claimsCount <= 0) {
        this.$('#claim-item-aside').addClass('not_display');
      } else {
        $('.send-claim').prop('disabled', false);
        this.$('#claim-item-aside').removeClass('not_display');
      }
      this.$('.b-bill__title').text(this.claimsNumberTemplate({ amount: this.claimsCount }));
    },

    /**
     * Перейти на другую страницу отзывов
     * @param page
     */
    paginate: function (page) {
      var top = this.$el.offset() && this.$el.offset().top || 0;
      $('html,body').animate({scrollTop: top}, 15);
      this.collection.getPage(page);
    },

    /**
     * Показать кнопку "Добавить товар"
     */
    showAddingButton: function () {
      this.$('.add-claim-item-row').removeClass('not_display');
    },

    /**
     * Скрыть кнопку "Добавить товар"
     */
    hideAddingButton: function () {
      this.$('.add-claim-item-row').addClass('not_display');
    },

    /**
     * Инициализация прелоадера для правого блока.
     */
    initAsideLoader: function() {
      this.childViews.asideLoader = new app.LoaderView({
        contentWrapper: this.$('.js-claim-item-aside'),
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
        isWhite: true,
      });
    },

    /**
     * Инициализация прелоадера для списка претензий.
     */
    initItemsLoader: function() {
      this.childViews.itemsLoader = new app.LoaderView({
        contentWrapper: this.$('.js-claims-list'),
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
      });
      this.renderItemsLoader();
    },

    /**
     * Добавить лоадер для правого блока.
     */
    renderAsideLoader: function() {
      this.childViews.asideLoader && this.childViews.asideLoader.render();
    },

    /**
     * Добавить лоадер для списка претензий.
     */
    renderItemsLoader: function() {
      this.childViews.itemsLoader && this.childViews.itemsLoader.render();
    },

    /**
     * Удалить лоадер для списка претензий.
     */
    removeItemsLoader: function() {
      this.childViews.itemsLoader && this.childViews.itemsLoader.remove();
    },

    /**
     * Показ формы добавления товара в претензию.
     */
    addClaimItem: function () {
      this.hideAddingButton();
      var model = new app.ClaimItem();
      var orderId = Number(this.urlParams.order_id);
      var sid = Number(this.urlParams.sid);
      $('.send-claim').prop('disabled', true);
      model.set('claim_id', this.claim_id);
      if (this.collection.models.length === 0 && orderId && sid) {
        model.set('order_id', orderId);
        model.set('sid', sid);
      }
      this.collection.add(model);
      if (this.childViews.claimItemForm) {
        this.childViews.claimItemForm.remove();
      }
      this.childViews.claimItemForm = new app.ClaimItemFormView({
        model: model,
        collection: this.collection
      });
      this.$('#claim-edit').append(this.childViews.claimItemForm.render().el);
    },
    /**
     * Закрыть форму добавления товара в претензию.
     */
    closeClaimItem: function () {
      if (this.childViews.claimItemForm && this.childViews.claimItemForm instanceof app.ClaimItemFormView) {
        if (this.childViews.claimItemForm.model.isNew()) {
          this.childViews.claimItemForm.model.destroy();
        }
        this.childViews.claimItemForm.remove();
        this.showAddingButton();
      }
    },

    /**
     *  Отправка претензии
     */
    sendClaim: function () {
      this.renderAsideLoader();
      this.claimModel.save('claim_status_id', 2);
      this.listenToOnce(this.claimModel, 'sync', this.reloadPage);
    },

    /**
     * Перезагрузка страницы
     */
    reloadPage: function () {
      window.location.reload();
    },

    /**
     * Сохранить как черновик
     */
    saveClaim: function () {
      app.helpers.RedirectHelper.locationAssign('/claim/');
    },
    /**
     * Удаление view
     * @param model
     */
    removeView: function (model) {
      var that = this;
      _.each(this.childViews.claimItems, function (key, index) {
        if (key && key.model === model) {
          that.childViews.claimItems.splice(index, 1);
        }
      });
    },
    /**
     * Инициализация попапа
     */
    initPopup: function () {
      var popup = $('.claim-edit-popup'),
        css,
        indent = 160;
      this.popup = new als.Popup(popup);
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          var offsetLeft = ($(window).width() - popup.outerWidth()) / 2;
          var offsetTop = window.pageYOffset + indent;
          if (!app.isDesktop) {
            offsetLeft = offsetLeft - $('body').position().left;
            offsetTop = offsetTop - $('body').position().top;
          }
          css = {
            left: offsetLeft,
            top: offsetTop
          };
          popup.css(css);
        }
      );
    },
    /**
     * Показать попап
     * @param model
     */
    showPopup: function (model) {
      this.closeClaimItem();
      this.childViews.claimPopupForm = new app.ClaimItemFormView({
        model: model,
        collection: this.collection,
        el: '.claim-edit-popup .claim-edit'
      });
      this.childViews.claimPopupForm.render();
      setTimeout((function () {
        this.popup.open();
      }).bind(this), 0);
    },
    /**
     * Закрыть претензию
     */
    cancelClaim: function () {
      $('.send-claim').prop('disabled', false);
      this.popup.close();
    },
  });
})();

}.call(window));